import React, {lazy} from 'react';
import {hydrateRoot} from "react-dom/client";
import {Route} from "react-router-dom";
import {Router} from "react-router";
import createBrowserHistory from "master/createBrowserHistory";

const DesktopStaticHeader = lazy(() => import('master/DesktopStaticHeader'));
const DesktopStaticFooter = lazy(() => import('master/DesktopStaticFooter'));
const MobileStaticHeader = lazy(() => import('master/MobileStaticHeader'));
const MobileStaticFooter = lazy(() => import('master/MobileStaticFooter'));

const history = createBrowserHistory({
  forceRefresh: true
})

const RouterWrapper = ({Component, state}) => {
  return (
    <Router history={history}>
      <Route
        path='*'
        component={(props) => <Component initialState={state} {...props} />}
      />
    </Router>
  )
}

const header = document.getElementById('static_header_root')
const footer = document.getElementById('static_footer_root')

if (window.STATIC_DATA['siteFormat'] === 'mobile') {
  header && hydrateRoot(header, <RouterWrapper state={window.__INITIAL_STATE_HEADER__} Component={MobileStaticHeader} />);
  footer && hydrateRoot(footer, <RouterWrapper state={window.__INITIAL_STATE_FOOTER__} Component={MobileStaticFooter} />);
} else {
  header && hydrateRoot(header, <RouterWrapper state={window.__INITIAL_STATE_HEADER__} Component={DesktopStaticHeader} />);
  footer && hydrateRoot(footer, <RouterWrapper state={window.__INITIAL_STATE_FOOTER__} Component={DesktopStaticFooter} />);
}
